import { render, staticRenderFns } from "./NumberControls.vue?vue&type=template&id=79ca12b3&"
import script from "./NumberControls.vue?vue&type=script&lang=ts&"
export * from "./NumberControls.vue?vue&type=script&lang=ts&"
import style0 from "./NumberControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports